import { render, staticRenderFns } from "./TrainingSet.vue?vue&type=template&id=79b6fd68&"
import script from "./TrainingSet.vue?vue&type=script&setup=true&lang=js&"
export * from "./TrainingSet.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports